<template>
    <section class="content">
        <div class="container-fluid">
            <div class="block-header">
                <h2>{{ name }}</h2>
            </div>
            <div class="row clearfix">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card">
                        <div class="header">
                            <h2>
                                Import Data {{ name }}
                            </h2>
                        </div>
                        <div class="body">
                            <form class="form-horizontal" v-on:submit.prevent="onSubmit">
                                <div class="col-12">
                                    <vue-dropzone v-on:vdropzone-error="failed" @vdropzone-success="vsuccess" ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import Ckeditor from 'vue-ckeditor2'
  import FormLine from '@/components/FormLine.vue'
  import api from '@/helper/api'
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    components: {FormLine, Ckeditor, vueDropzone: vue2Dropzone},
    name: 'Upload',
    data: function () {
      return {
        dropzoneOptions: {
          url: api.defaults.baseURL + '/' + this.link,
          thumbnailWidth: 150,
          maxFilesize: 200,
          headers: { 'Authorization': 'Bearer ' + localStorage.getItem('_token') }
        },
        name: '',
        link: ''
      }
    },
    methods: {
      vsuccess (file, response) {
        this.success = true
        console.log(response)
      },
      failed (file, m, xhr) {
        this.$swal('Perhatian', m.message, 'error')
        this.$refs.myVueDropzone.removeAllFiles()
      },
      checkRoute () {
        this.$refs.myVueDropzone.removeAllFiles()
        if (this.$route.name === 'CetakStrukMP') {
          this.$refs.myVueDropzone.setOption('url', api.defaults.baseURL + '/import-cetak-mp')
          this.name = 'Cetak Struk MP'
        } else if (this.$route.name === 'CetakStrukUangPembinaan') {
          this.$refs.myVueDropzone.setOption('url', api.defaults.baseURL + '/import-cetak-uang-pembinaan')
          this.name = 'Cetak Struk Uang Pembinaan'
        } else if (this.$route.name === 'CetakStrukRapel') {
          this.$refs.myVueDropzone.setOption('url', api.defaults.baseURL + '/import-cetak-rapel')
          this.name = 'Cetak Struk Rapel Kenaikan'
        } else if (this.$route.name === 'CetakSPT') {
          this.$refs.myVueDropzone.setOption('url', api.defaults.baseURL + '/import-cetak-spt')
          this.name = 'Cetak SPT'
        }
      }
    },
    mounted () {
      this.checkRoute()
    },
    watch: {
      '$route': function (a, b, c) {
        this.checkRoute()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/Upload.vue?2409d62b